"use strict";
// Enable crypto package in IE
if (!window.crypto && "msCrypto" in window) {
    window.crypto = window.msCrypto;
}
//# sourceMappingURL=polyfills.js.map